import { InstallPermissionAccessState } from '../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc';

export type SupportedInstallPermissionTypes = Extract<
  InstallPermissionAccessState,
  | 'EVERYONE'
  | 'SUPER_ADMINS_AND_AUTHORIZED_INSTALLERS'
  | 'SPECIFIC_USERS_AND_TEAMS'
>;

export const InstallPermissionAccessTypes: Record<
  SupportedInstallPermissionTypes,
  SupportedInstallPermissionTypes
> = {
  EVERYONE: 'EVERYONE',
  SUPER_ADMINS_AND_AUTHORIZED_INSTALLERS:
    'SUPER_ADMINS_AND_AUTHORIZED_INSTALLERS',
  SPECIFIC_USERS_AND_TEAMS: 'SPECIFIC_USERS_AND_TEAMS',
};
